import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import jinx1 from "../../assets/jinx1.png";
import ninja from "../../assets/ninja1.png";
import jini1 from "../../assets/jini1.png";
import hip from "../../assets/hip21.png";
import superman from "../../assets/superman.png";
import Aos from "aos";
import { BsDashLg } from "react-icons/bs";
function CarouselComponent(props) {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  });
  const CustomDot = ({ onMove, index, onClick, active }) => {
    // onMove means if dragging or swiping in progress.
    // active is provided by this lib for checking if the item is active or not.
    return (
      <li
        className={active ? "text-white font-black" : "text-[#646AFB]" }
        onClick={() => onClick()}
        
      >
        <BsDashLg size={25} className="mr-2"/>
      </li>
    );
  };
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Carousel
      responsive={responsive}
      arrows={false}
      infinite={true}
      autoPlay={true}
      autoPlaySpeed={2000}
      keyBoardControl={true}
      customTransition="all .5"
      showDots={true}
      renderDotsOutside={true}
      centerMode={true}
      focusOnSelect={true}
      dotListClass="custom-dot-list-style"
      customDot={<CustomDot />}
    >
      <div data-aos="zoom-in" className="w-full lg:w-full h-full">
        <img src={jinx1} alt="" className="w-11/12" />
      </div>
      <div data-aos="zoom-in" className="w-full lg:w-full h-full">
        <img src={ninja} alt="" className="w-11/12" />
      </div>
      <div data-aos="zoom-in" className="  w-full lg:w-full h-full">
        <img src={hip} alt=""className="w-11/12" />
      </div>
      <div data-aos="zoom-in" className="  w-full lg:w-full h-full">
        <img src={superman} alt=""className="w-11/12" />
      </div>
      <div data-aos="zoom-in" className="  w-full lg:w-full h-full">
        <img src={jini1} alt=""className="w-11/12" />
      </div>
    </Carousel>
  );
}

export default CarouselComponent;
